type ValidHttpParams =
  string | number | boolean | readonly (string | number | boolean)[];

export const addParams = <
  T extends Record<string, Nullable<ValidHttpParams | undefined>>,
>(
  params: T
): NonNullableValues<T> =>
  Object.keys(params).reduce<NonNullableValues<T>>(
    (result, key) => (
      params[key] !== null &&
        params[key] !== undefined &&
        ((result as Record<string, ValidHttpParams>)[key] = params[key]),
      result
    ),
    {} as NonNullableValues<T>
  );
